import React from "react";
import { ServiceHelper } from "@modules";
import { typeBindService } from "@services/Settings";
import { DataTable } from "../Common";
import { DataTableColumn } from "../Common/DataTable/DataTable";
import { useSnackbar } from "notistack";
import { TypeBind } from "@interfaces/TypeBind";
import { useCurrentPageInfo, useModal } from "@hooks";

const TypeBindTable = () => {
    const { permission } = useCurrentPageInfo();
    const { enqueueSnackbar } = useSnackbar();
    const { handleOpenModal } = useModal();

    const handleEditClick = (rowData) => {
        handleOpenModal("EDIT_TYPE_BIND", { itemId: rowData.id });
    };

    const handleDeleteClick = async (rowData: TypeBind | TypeBind[]) => {
        try {
            const ids = ServiceHelper.getIdsListFromRowDataObject(rowData);
            await typeBindService.deleteTypeBind(ids);
            enqueueSnackbar("Настройка успешно удалена", {
                variant: "success",
            });
        } catch (err) {
            const message = err.response.data.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при удалении настройки", {
                variant: "error",
            });
        }
    };

    const columns: DataTableColumn<TypeBind>[] = [
        {
            title: "#",
            field: "id",
            defaultSort: "asc",
            width: 50,
        },
        {
            title: "Название",
            field: "type_name",
            width: "auto",
        },
        {
            title: "Тип сущности",
            field: "type_id",
            width: "auto",
        },
    ];

    return (
        <DataTable
            fetchFn={typeBindService.getTypeBind}
            columns={columns}
            displayField="type_name"
            permission={permission}
            sorting
            selection
            search
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}
            onMassDeleteClick={handleDeleteClick}
        />
    );
};

export default TypeBindTable;
